/**
 * Standalone page kept for backwards compatibility (existing
 * bookmarks / share links to `/comunicacion-estandar`). The actual
 * editor lives in `<BrandVoicePanel/>` and is also embedded inside
 * Copy Studio as a slide-over panel.
 */
import Sidebar from "../components/Sidebar";
import BrandVoicePanel from "../components/BrandVoicePanel";
import { BookOpen } from "lucide-react";

export default function CommunicationStandard() {
    return (
        <div className="flex h-screen bg-ink-950 overflow-hidden">
            <Sidebar />
            <main className="flex-1 overflow-y-auto">
                <header className="px-8 pt-8 pb-3 flex items-center gap-3">
                    <BookOpen className="w-5 h-5 text-emerald-400" />
                    <h1 className="text-lg font-display tracking-tight text-fog-100">
                        Reglas del copy
                    </h1>
                </header>
                <p className="px-8 mb-6 text-sm text-fog-400">
                    Configuración general del prompt — todo lo que el copy debe cumplir al generarse.
                </p>
                <div className="px-8 pb-16 max-w-6xl">
                    <BrandVoicePanel />
                </div>
            </main>
        </div>
    );
}
